import { createFileRoute } from '@tanstack/react-router'
import { contentRepository } from '@/data/adapters/mock/content.mock'

export const Route = createFileRoute('/$orgSlug/$clientSlug/content')({
  loader: ({ context: { queryClient, client } }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: ['content', 'submissions', client.id],
        queryFn: () => contentRepository.getContentSubmissions(client.id),
      }),
      queryClient.ensureQueryData({
        queryKey: ['content', 'spark-codes', client.id],
        queryFn: () => contentRepository.getSparkCodes(client.id),
      }),
    ]),
})
